/**
 * @param {string|number} value
 * @param {boolean} roundUp
 * @return {string}
 */
function toDollars(value, roundUp = false) {
    let asFloat = Number.parseFloat(value);

    if (roundUp) {
        asFloat = Math.ceil(asFloat);
    }

    let asDollars = asFloat.toFixed(2);

    // Remove .00 if not required
    asDollars = asDollars.replace(/\.00$/, '');

    // Add dollar sign
    if (asFloat >= 0) {
        asDollars = `$${asDollars}`;
    } else {
        asDollars = `-$${asDollars}`;
    }

    return asDollars;
}

/**
 * @param {string|number} value1
 * @param {string|number} value2
 * @param {boolean} roundUp
 * @return {string}
 */
function toPriceRange(value1, value2, roundUp = false) {
    return `${toDollars(value1, roundUp)} - ${toDollars(value2, roundUp)}`;
}

export {toDollars, toPriceRange};
